<template>
  <div>
    <p class="title text-left">全员齐动，稳中求进——2019及时雨小贷团建</p>
    <p class="desc text-left">
      2019-10-26
      <span class="author">及时雨小额贷款</span>
    </p>
    <div class="main-content text-left">
        <p class="center">盼望着，盼望着</p>
        <p class="center">团建来啦！</p>
        <div class="normal">
            <img src="../img/newsDetail/8-01.png" width="100%" alt="未显示"/>
        </div>
        <div class="normal">150余人的能量之旅，放松心情，锻炼身体！</div>
        <div class="normal">
            <img src="../img/newsDetail/8-02.png" width="90%" alt />
        </div>
        <div class="two-container">
            <p class="sub-con"><img src="../img/newsDetail/8-03.png" width="100%" alt /></p>
            <p class="sub-con"><img src="../img/newsDetail/8-04.png" width="100%" alt /></p>
        </div>
        <p class="normal">热身运动，全身动起来！</p>
        <div class="line-div">
            <p class="horital-line"></p>
            <span class="border-titl">脑力体力大PK</span>
        </div>
        <div class="slope">
            <img src="../img/newsDetail/8-05.png" width="70%" alt />
        </div>
        <div class="normal">
            <img src="../img/newsDetail/8-06.png" width="70%" alt />
        </div>
        <div class="slope">
            <img src="../img/newsDetail/8-07.png" width="70%" alt />
        </div>
        <div class="normal">
            <img src="../img/newsDetail/8-08.png" width="70%" alt />
        </div>
        <p class="normal">珠行万里、四字棋、地图游戏，团队大协作，一个都不能少！</p>
        <div class="normal">
            <img src="../img/newsDetail/8-09.png" width="100%" alt />
        </div>
        <div class="normal">
            <img src="../img/newsDetail/8-10.png" width="100%" alt />
        </div>
        <div class="center">
            摸石过河<br>
            一步一个脚印<br>
            就像及时雨小贷这6年的发展<br>
            走的快更要走的稳
        </div>
        <div class="normal">
            <img src="../img/newsDetail/8-21.png" width="100%" alt />
        </div>
        <div class="normal">
            <img src="../img/newsDetail/8-22.png" width="100%" alt />
        </div>
        <div class="normal">
            <img src="../img/newsDetail/8-23.png" width="100%" alt />
        </div>
        <p class="center">躲避球<br>
        考验脑力更考验体力<br>
        长时间坐办公室工作的小伙伴<br>
        平时也不要忘记锻炼哦</p>
        <div class="two-container">
            <p class="sub-con"><img src="../img/newsDetail/8-11.png" width="100%" alt /></p>
            <p class="sub-con"><img src="../img/newsDetail/8-12.png" width="100%" alt /></p>
        </div>
          <p class="center">
              和老板比赛平板撑<br>
               猜猜谁会赢？<br>
           </p>
        <div class="line-div">
            <p class="horital-line"></p>
            <span class="border-titl">玩游戏还能拿奖</span>
        </div>
        <div class="two-container two-center" style="margin-top:40px;right: -6%;">
            <p class="sub-con"><img src="../img/newsDetail/8-13.png" width="100%" alt /></p>
            <p class="sub-con"><img src="../img/newsDetail/8-14.png" width="100%" alt /></p>
        </div>
        <div class="two-container two-center" style="right: -6%;">
            <p class="sub-con"><img src="../img/newsDetail/8-15.png" width="100%" alt /></p>
            <p class="sub-con"><img src="../img/newsDetail/8-16.png" width="100%" alt /></p>
        </div>
        <p class="center">
            恭喜获奖的小团队<br>
            独木不成林<br>
            一群人才能走的更远
         </p>
        <div class="two-container two-center" style="margin-top:40px;right: -6%;">
            <p class="sub-con"><img src="../img/newsDetail/8-17.png" width="100%" alt /></p>
            <p class="sub-con"><img src="../img/newsDetail/8-18.png" width="100%" alt /></p>
        </div>
        <div class="two-container two-center" style="right: -6%;">
            <p class="sub-con"><img src="../img/newsDetail/8-19.png" width="100%" alt /></p>
            <p class="sub-con"><img src="../img/newsDetail/8-20.png" width="100%" alt /></p>
        </div>
         <p class="center">
           快乐的时光总是短暂的，有了能量之旅加油助威，相信大家会更努力工作，助公司发展<br>
           再上一层楼！
         </p>
    </div>
  </div>
</template>

<script>
export default {
    name: "NewsDetail10"
};
</script>

<style scoped lang="less">
@import "newsDetail.less";
</style>


// WEBPACK FOOTER //
// src/components/NewsDetail10.vue